import { useContext } from "react";

import {
  CarriersContext,
  type CarriersContextValue,
} from "../contexts/carriersContext";

export const useCarriers = (): CarriersContextValue => {
  const context = useContext(CarriersContext);
  if (context === undefined) {
    throw new Error("useCarriers must be used within a CarriersProvider");
  }

  return context;
};
